import type { DetailTabId } from "../types.js";

export function isClinicianDetailDialogRoute(
  selectedDetailTabId: DetailTabId,
): boolean {
  return selectedDetailTabId !== "information";
}

export function shouldRenderClinicianDetailSurface(
  isWideLayout: boolean,
  selectedDetailTabId: DetailTabId,
): boolean {
  return (
    isWideLayout || isClinicianDetailDialogRoute(selectedDetailTabId)
  );
}

export function shouldOpenClinicianDetailDialog(input: {
  hasPrimaryDialog: boolean;
  isWideLayout: boolean;
  legacyStageHeight?: number;
  selectedDetailTabId: DetailTabId;
}): boolean {
  if (
    input.hasPrimaryDialog ||
    !isClinicianDetailDialogRoute(input.selectedDetailTabId)
  ) {
    return false;
  }

  return !input.isWideLayout || input.legacyStageHeight != null;
}
